import { defineComponent, openBlock, createElementBlock, Fragment, renderList, createBlock } from "@histoire/vendors/vue";
import StoryListItem from "./StoryListItem.js";
import StoryListFolder from "./StoryListFolder.js";
import "./StoryGroup.js";
import _sfc_main$1 from "./StoryGroup.vue_vue_type_script_setup_true_lang.js";
const _hoisted_1 = { class: "histoire-story-list htw-overflow-y-auto" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "StoryList",
  props: {
    tree: null,
    stories: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.tree, (element) => {
          return openBlock(), createElementBlock(Fragment, {
            key: element.title
          }, [
            element.group ? (openBlock(), createBlock(_sfc_main$1, {
              key: 0,
              group: element,
              stories: __props.stories
            }, null, 8, ["group", "stories"])) : element.children ? (openBlock(), createBlock(StoryListFolder, {
              key: 1,
              folder: element,
              stories: __props.stories
            }, null, 8, ["folder", "stories"])) : (openBlock(), createBlock(StoryListItem, {
              key: 2,
              story: __props.stories[element.index]
            }, null, 8, ["story"]))
          ], 64);
        }), 128))
      ]);
    };
  }
});
export {
  _sfc_main as default
};
